import { API_BASE_URL } from "../config/apiConfig"

/**
 * Fetch all available currencies from the new currencies API
 * @param {string} token - Company authorization token
 * @returns {Promise<Array>} Array of currency objects with code, name, and countryName
 */
export const getAllCurrencies = async (token) => {
  try {
    const headers = {
      "Content-Type": "application/json",
    }

    if (token) {
      headers["Authorization"] = `Bearer ${token}`
    }

    const response = await fetch(`${API_BASE_URL}/currencies`, {
      method: "GET",
      headers: headers,
    })

    if (!response.ok) {
      throw new Error("Failed to fetch currencies")
    }

    const data = await response.json()

    if (data.success && Array.isArray(data.data)) {
      return data.data.map((currency) => ({
        code: currency.currencyCode,
        name: currency.currencyName,
        countryName: currency.countryName,
      }))
    }

    // Fallback if data is directly an array
    if (Array.isArray(data)) {
      return data.map((currency) => ({
        code: currency.currencyCode,
        name: currency.currencyName,
        countryName: currency.countryName,
      }))
    }

    throw new Error("Invalid response format")
  } catch (error) {
    console.error("Error fetching currencies:", error)
    return []
  }
}
